import {
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
  CREATE_CREDENTIALSNT,
  DELETE_CREDENTIALSNT,
  GET_CREDENTIALSNT,
  UPDATE_CREDENTIALSNT,
  GET_CREDENTIALSNT_STATES,
  GET_CREDENTIALSNT_SPECIALTIES,
} from './actionType';

// common success
export const CredentialsNTApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const CredentialsNTApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetCredentialsNT = (status, params) => ({
  type: GET_CREDENTIALSNT,
  payload: { status, params },
});

export const CreateCredentialsNT = (data) => ({
  type: CREATE_CREDENTIALSNT,
  payload: { data },
});

export const UpdateCredentialsNT = (data) => ({
  type: UPDATE_CREDENTIALSNT,
  payload: { data },
});

export const DeleteCredentialsNT = (id) => ({
  type: DELETE_CREDENTIALSNT,
  payload: { id },
});

export const GetCredentialsNTStates = () => ({
  type: GET_CREDENTIALSNT_STATES,
});

export const GetCredentialsNTSpecialties = (params) => ({
  type: GET_CREDENTIALSNT_SPECIALTIES,
  payload: { params },
});
